import { environment } from '@env/environment';
import permissions from '@permissions/permissions.json';

export const isAdmin = (admin: string, agent: string): string =>
    environment.role === 'admin' ? admin : agent;

export const permissionGetter = (majorPermission: string, minorPermission: string): string[] =>
    permissions[majorPermission][minorPermission];
